import React from 'react';
import { stats } from '../data/stats';
import Counter from '../components/Counter';
import Reveal from '../components/Reveal';

export default function Stats() {
  return (
    <section className="section">
      <div className="container">
        <Reveal className="heading heading--center"><h2>Our Achievements</h2></Reveal>
        <div className="stats">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={(i % 3) * 80}>
              <div className={`stat ${s.value != null && String(s.value).length >= 7 ? 'stat--long' : ''}`}>
                <strong><Counter value={s.value} suffix={s.suffix} /></strong>
                <span>{s.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
